import React from 'react';
import { withStyles, WithStyles, createStyles, Theme } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

import { withIntl, IntlProps } from 'ha/i18n';

import { CloseBtn } from 'ha/ui/next/Modal';
import units from 'ha/theme/units';

const styles = (t: Theme) =>
  createStyles({
    title: {
      padding: units.yx(0.75, 1),
      borderBottom: units.border(1, 'solid', t.palette.grey[400]),
    },
  });

interface Props {
  onClose: () => void;
}

export const SearchAlertMobileTitle: React.FC<
  Props & IntlProps & WithStyles<typeof styles>
> = ({ classes, onClose, intl: { T } }) => (
  <Typography variant="h6" className={classes.title}>
    {T('Search alert')} <CloseBtn onClose={onClose} />
  </Typography>
);

export default withStyles(styles)(withIntl(SearchAlertMobileTitle));
